/* eslint-disable react/prop-types */
import { debounce } from 'lodash';
import { FieldArray } from 'formik';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useEffect, useState } from 'react';
// components
import Input from '../../components/Input';
import Select from '../../components/Select';
// hooks
import { useWindowSize } from '../../../../Hooks/use-window-size';

const MessengerLinkComponent = ({
  t,
  link,
  push,
  index,
  remove,
  touched,
  errors = {},
  setFieldValue,
  messengers = [],
  setFieldTouched,
  handleChangeLink,
  messenger_links = [],
}) => {
  const selectedMessengers = messenger_links.map(link => link.type);
  const availableMessengers = messengers.filter(messenger => !selectedMessengers.includes(messenger) || messenger === link.type);

  const inputType = link.type === 'Telegram' || link.type === 'Discord' || link.type === 'Skype' ? 'text' : 'tel';

  const label = !link.type || link.type === 'Telegram'
    ? t('jobseekerEditProfile.messengerLink')
    : link.type === 'Discord' || link.type === 'Skype'
      ? t('jobseekerEditProfile.messengerNickname')
      : t('jobseekerEditProfile.messengerContactNumber');

  const placeholder = !link.type || link.type === 'Telegram'
    ? t('jobseekerEditProfile.messengerLink')
    : link.type === 'Discord' || link.type === 'Skype'
      ? t('jobseekerEditProfile.messengerNickname')
      : t('jobseekerEditProfile.contactNumberPlaceholder');

  const handleFocus = e => {
    const { name, value } = e.target;

    if (value) return;

    if (['WhatsApp', 'Viber', 'Signal'].includes(link.type)) {
      setFieldValue(name, '+380');
    }
  };

  const handleBlur = e => {
    const { name, value } = e.target;
    const updatedValue = value === '+380' ? '' : value;

    if (['WhatsApp', 'Viber', 'Signal'].includes(link.type)) {
      setFieldValue(name, updatedValue);
    }
  };

  const handleInputChange = e => {
    const { name, value } = e.target;

    setFieldValue(name, value);
  };

  return (
    <div className='row'>
      <Select
        value={link.type}
        options={availableMessengers}
        required={link.link || link.type}
        name={`messenger_links[${index}].type`}
        label={t('jobseekerEditProfile.messenger')}
        error={errors?.messenger_links?.[index]?.type}
        touched={touched?.messenger_links?.[index]?.type}
        defaultOption={t('jobseekerEditProfile.messenger')}
        errorMessage={errors?.messenger_links?.[index]?.type}
        handleBlur={() => setFieldTouched(`messenger_links[${index}].type`, true)}
        className={classNames('col-lg-3', { 'mb-lg-0': link.type === 'Telegram' })}
        handleChange={e => handleChangeLink('messenger_links', index, 'type', e.target.value)}
      />
      <Input
        label={label}
        type={inputType}
        value={link.link}
        handleFocus={handleFocus}
        placeholder={placeholder}
        required={link.link || link.type}
        name={`messenger_links[${index}].link`}
        handleChange={e => handleInputChange(e)}
        error={errors?.messenger_links?.[index]?.link}
        touched={touched?.messenger_links?.[index]?.link}
        errorMessage={errors?.messenger_links?.[index]?.link}
        className={classNames('col-lg-6', { 'mb-lg-0': link.type === 'Telegram' })}
        handleBlur={e => {
          handleBlur(e);
          setFieldTouched(`messenger_links[${index}].link`, true);
        }}
      />
      <div className={classNames('mb-4 col-lg-3 text-center', { 'mb-lg-0': link.type === 'Telegram' })}>
        {
          index === messenger_links.length - 1 && availableMessengers.length > 1 && messenger_links.length < messengers.length
            ? (
              <button
                type='button'
                className='btn btn-primary button1 mt-lg-2'
                onClick={() => push({ link: '', type: '' })}
              >
                {t('jobseekerEditProfile.addMoreButton')}
              </button>
            ) : (
              <button
                type='button'
                onClick={() => remove(index)}
                className='btn btn-danger button2 mt-lg-2'
              >
                {t('jobseekerEditProfile.removeButton')}
              </button>
            )
        }
      </div>
      {
        link.type === 'Telegram' && (
          <div className={`${index < messenger_links.length - 1 ? 'mb-4' : ''} form-text mt-0`}>
            {t('jobseekerEditProfile.messengerLinkTelegramBelowTxt')}
          </div>
        )
      }
    </div>
  );
};

const SocialLinkComponent = ({
  t,
  link,
  push,
  index,
  remove,
  touched,
  errors = {},
  socials = [],
  setFieldValue,
  setFieldTouched,
  handleChangeLink,
  social_links = [],
}) => {
  const selectedSocials = social_links.map(link => link.type);
  const availableSocials = socials.filter(social => !selectedSocials.includes(social) || social === link.type);

  const handleInputChange = e => {
    const { name, value } = e.target;

    setFieldValue(name, value);
  };

  return (
    <div className='row' key={index}>
      <Select
        value={link.type}
        className='col-lg-3'
        options={availableSocials}
        name={`social_links[${index}].type`}
        label={t('jobseekerEditProfile.social')}
        error={errors?.social_links?.[index]?.type}
        touched={touched?.social_links?.[index]?.type}
        defaultOption={t('jobseekerEditProfile.social')}
        errorMessage={errors?.social_links?.[index]?.type}
        required={social_links[index]?.link || social_links[index]?.type}
        handleBlur={() => setFieldTouched(`social_links[${index}].type`, true)}
        handleChange={e => handleChangeLink('social_links', index, 'type', e.target.value)}
      />
      <Input
        value={link.link}
        className='col-lg-6'
        name={`social_links[${index}].link`}
        handleChange={e => handleInputChange(e)}
        error={errors?.social_links?.[index]?.link}
        label={t('jobseekerEditProfile.socialLink')}
        touched={touched?.social_links?.[index]?.link}
        errorMessage={errors?.social_links?.[index]?.link}
        placeholder={t('jobseekerEditProfile.socialLink')}
        required={social_links[index]?.link || social_links[index]?.type}
        handleBlur={() => setFieldTouched(`social_links[${index}].link`, true)}
      />
      <div className='col-lg-3 mb-4 text-center'>
        {
          index === social_links.length - 1 && availableSocials.length > 1 && social_links.length < socials.length
            ? (
              <button
                type='button'
                className='btn btn-primary button1 mt-lg-2'
                onClick={() => push({ link: '', type: '' })}
              >
                {t('jobseekerEditProfile.addMoreButton')}
              </button>
            ) : (
              <button
                type='button'
                onClick={() => remove(index)}
                className='btn btn-danger button2 mt-lg-2'
              >
                {t('jobseekerEditProfile.removeButton')}
              </button>
            )
        }
      </div>
    </div>
  );
};

const ContactInformationBlock = ({ errors, values, touched, directories, handleChange, setFieldValue, setFieldTouched }) => {
  const { width } = useWindowSize();
  const { t } = useTranslation('global');

  const { socials = [], messengers = [] } = directories;

  const {
    social_links = [],
    email_address = '',
    video_cv_link = '',
    contact_number = '',
    messenger_links = [],
    contact_number_2 = '',
    contact_number_3 = '',
  } = values;

  const [videoLink, setVideoLink] = useState(video_cv_link || '');
  const [contactNumber, setContactNumber] = useState(contact_number || '');
  const [contactNumber2, setContactNumber2] = useState(contact_number_2 || '');
  const [contactNumber3, setContactNumber3] = useState(contact_number_3 || '');

  const contactNumberFields = [
    {
      required: true,
      value: contactNumber,
      name: 'contact_number',
      error: errors.contact_number,
      className: 'col-lg-4 mb-lg-0',
      touched: touched.contact_number,
      handleFocus: e => handleFocus(e),
      handleChange: e => handleInputChange(e),
      label: t('jobseekerEditProfile.contactNumber'),
      placeholder: t('jobseekerEditProfile.contactNumberPlaceholder'),
      handleBlur: e => {
        handleBlur(e);
        setFieldTouched('contact_number', true);
      },
    },
    {
      value: contactNumber2,
      name: 'contact_number_2',
      className: 'col-lg-4 mb-lg-0',
      error: errors.contact_number_2,
      handleFocus: e => handleFocus(e),
      touched: touched.contact_number_2,
      handleChange: e => handleInputChange(e),
      label: t('jobseekerEditProfile.contactNumber'),
      placeholder: t('jobseekerEditProfile.contactNumberPlaceholder'),
      handleBlur: e => {
        handleBlur(e);
        setFieldTouched('contact_number_2', true);
      },
    },
    {
      value: contactNumber3,
      name: 'contact_number_3',
      className: 'col-lg-4 mb-lg-0',
      error: errors.contact_number_3,
      handleFocus: e => handleFocus(e),
      touched: touched.contact_number_3,
      handleChange: e => handleInputChange(e),
      label: t('jobseekerEditProfile.contactNumber'),
      placeholder: t('jobseekerEditProfile.contactNumberPlaceholder'),
      handleBlur: e => {
        handleBlur(e);
        setFieldTouched('contact_number_3', true);
      },
    },
  ];

  const handleFocus = e => {
    const { name, value } = e.target;

    if (value) return;

    if (name === 'contact_number') {
      setContactNumber('+380');
    } else if (name === 'contact_number_2') {
      setContactNumber2('+380');
    } else if (name === 'contact_number_3') {
      setContactNumber3('+380');
    }
  };

  const handleBlur = e => {
    const { name, value } = e.target;
    const updatedValue = value === '+380' ? '' : value;

    if (name === 'contact_number') {
      setContactNumber(updatedValue);
    } else if (name === 'contact_number_2') {
      setContactNumber2(updatedValue);
    } else if (name === 'contact_number_3') {
      setContactNumber3(updatedValue);
    }
  };

  const handleInputChange = useCallback(e => {
    const { name, value } = e.target;

    if (name === 'contact_number') {
      setContactNumber(value);
    } else if (name === 'contact_number_2') {
      setContactNumber2(value);
    } else if (name === 'contact_number_3') {
      setContactNumber3(value);
    } else {
      setVideoLink(value);
    }

    debouncedHandleInputChange(name, value);
  }, []); // eslint-disable-line

  const handleChangeLink = (linkType, index, field, value) => {
    setFieldValue(`${linkType}[${index}].${field}`, value);
  };

  const debouncedHandleInputChange = debounce((name, value) => {
    setFieldValue(name, value);
  }, 500);

  useEffect(() => {
    if (width >= 768) {
      window.scrollTo({ top: 350, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 650, behavior: 'smooth' });
    }
  }, [width]);

  return (
    <>
      <Input
        disabled
        required
        name='email_address'
        value={email_address}
        handleChange={handleChange}
        error={errors.email_address}
        touched={touched.email_address}
        label={t('jobseekerEditProfile.emailAddress')}
        placeholder={t('jobseekerEditProfile.emailAddress')}
      />
      <div className='row mb-4'>
        {
          contactNumberFields.map(i => (
            <Input
              key={i.name}
              name={i.name}
              error={i.error}
              label={i.label}
              value={i.value}
              touched={i.touched}
              required={i.required}
              className={i.className}
              handleBlur={i.handleBlur}
              handleFocus={i.handleFocus}
              placeholder={i.placeholder}
              handleChange={i.handleChange}
            />
          ))
        }
        {
          (
            (touched.contact_number && errors.contact_number) ||
            (touched.contact_number_2 && errors.contact_number_2) ||
            (touched.contact_number_3 && errors.contact_number_3)
          ) && (
            <div className='text-danger'>
              {errors.contact_number || errors.contact_number_2 || errors.contact_number_3}
            </div>
          )
        }
      </div>
      <div className='mt-4 mb-4'>
        <FieldArray
          name='messenger_links'
          render={({ push, remove }) => (
            messenger_links.map((link, index) => (
              <MessengerLinkComponent
                t={t}
                key={index}
                link={link}
                push={push}
                index={index}
                errors={errors}
                remove={remove}
                touched={touched}
                messengers={messengers}
                setFieldValue={setFieldValue}
                messenger_links={messenger_links}
                setFieldTouched={setFieldTouched}
                handleChangeLink={handleChangeLink}
                debouncedHandleInputChange={debouncedHandleInputChange}
              />
            ))
          )}
        />
      </div>
      <hr />
      <div className='mt-5'>
        <FieldArray
          name='social_links'
          render={({ push, remove }) => (
            social_links.map((link, index) => (
              <SocialLinkComponent
                t={t}
                key={index}
                link={link}
                push={push}
                index={index}
                errors={errors}
                remove={remove}
                socials={socials}
                touched={touched}
                social_links={social_links}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                handleChangeLink={handleChangeLink}
                debouncedHandleInputChange={debouncedHandleInputChange}
              />
            ))
          )}
        />
      </div>
      <Input
        className='mb-5'
        value={videoLink}
        name='video_cv_link'
        error={errors.video_cv_link}
        touched={touched.video_cv_link}
        errorMessage={errors.video_cv_link}
        handleChange={e => handleInputChange(e)}
        label={t('jobseekerEditProfile.videoCV')}
        placeholder={t('jobseekerEditProfile.addLink')}
        note={t('jobseekerEditProfile.videoCVBelowTxt')}
        handleBlur={() => setFieldTouched('video_cv_link', true)}
      />
    </>
  );
};

export default ContactInformationBlock;
